import { render, staticRenderFns } from "./DashboardNotification.vue?vue&type=template&id=4e2a89fc&scoped=true&"
import script from "./DashboardNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotification.vue?vue&type=style&index=0&id=4e2a89fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a89fc",
  null
  
)

export default component.exports